const currencyToLocale = {
  CHF: "de_CH",
  DKK: "da",
  INR: "en_IN",
  NOK: "nn",
  SEK: "sv",
  PLN: "pl"
};
const typeToStyle = {
  string: "string",
  money: "currency",
  integer: "decimal",
  float: "decimal",
  percentage: "percent",
  duration: "decimal"
};
const DEFAULT_LOCALE = new Intl.Locale("sv-SE");
const DEFAULT_CURRENCY_LOCALE = new Intl.Locale("en-US");
const formatValue = (value, {
  short,
  type,
  locale = DEFAULT_LOCALE,
  currency = "SEK",
  precision = 2
}) => {
  let overrideLocale = null;
  if (value === null || isNaN(value)) return "—";
  if (type === "string") return value.toString();
  if (type === "money" && (!currency || currency.length !== 3)) {
    console.warn(`[formatValue]: currency code is missing or invalid (${currency}). Falling back to SEK`);
  }
  const safeCurrency = currency && currency.length === 3 ? currency.toUpperCase() : "SEK";
  if (type === "money" && safeCurrency) {
    overrideLocale = currencyToLocale[safeCurrency] || DEFAULT_CURRENCY_LOCALE.toString();
  }
  const formatter = new Intl.NumberFormat(overrideLocale || locale.toString(), {
    style: typeToStyle[type],
    ...type === "money" ? {
      currency: safeCurrency
    } : {},
    ...short ? {
      notation: "compact"
    } : {},
    minimumFractionDigits: type === "integer" ? 0 : precision,
    maximumFractionDigits: type === "integer" ? 0 : precision
  });
  const formattedValue = formatter.format(value);
  if (type === "percentage") {
    return formattedValue.replace(" %", "%").replace(" %", "%");
  }
  return formattedValue;
};
const getYAxisWidth = (digits) => Math.min(100, Math.max(10, (digits + 1) * 8 + 6));
const makeValueFormatter = (col, precisionOverride) => {
  if (!col) return void 0;
  const {
    type,
    currency
  } = col;
  if (type === "boolean" || type === "icon" || type === "link" || type === "string") return void 0;
  const vt = type;
  const defaultPrecision = col.precision ?? (vt === "integer" ? 0 : vt === "percentage" ? 1 : 2);
  const precision = precisionOverride ?? defaultPrecision;
  return (value) => formatValue(value, {
    type: vt,
    short: col.short ?? false,
    currency,
    precision
  });
};
export {
  formatValue,
  getYAxisWidth,
  makeValueFormatter,
  typeToStyle
};
